import _ from 'lodash';
import {
  StyledInvestmentBreakdown,
  StyledIssueRow
} from './InvestmentBreakdown.style';
import { mapPmProviderToViewer } from 'common/hooks/pm/usePmViewer/usePmViewer.utils';

const InvestmentBreakdown = ({ pointData, resourceType }) => {
  const topIssues = _.get(pointData, 'issues.top_issues', []);
  const orderedTopIssues = _.orderBy(
    topIssues,
    issue => issue.issues_p,
    'desc'
  );

  const lastIssuePercentage =
    100 -
    orderedTopIssues
      .slice(0, -1)
      .reduce((acc, issue) => acc + Number(_.round(issue.issues_p)), 0);

  const pmViewer = mapPmProviderToViewer(resourceType.pmProvider);

  return (
    <StyledInvestmentBreakdown data-cy='allocation-investment-breakdown'>
      <div className='header'>Investment per {pmViewer.issueType.single}</div>
      <div className='main'>
        {orderedTopIssues.map((issue, idx) => {
          const isLast = idx === topIssues.length - 1;
          const issueType = _.get(issue, 'issue_provider_type');
          const percent = isLast
            ? lastIssuePercentage
            : _.round(_.get(issue, 'issues_p', 0));
          return (
            <StyledIssueRow key={idx}>
              <div className='issue-type'>
                {issueType} ({percent}%)
              </div>
            </StyledIssueRow>
          );
        })}
      </div>
    </StyledInvestmentBreakdown>
  );
};

export default InvestmentBreakdown;
